// DS ui_kits/grackle-app/SettingsScreen.jsx `Section` (SD35): one white card per settings group,
// a Hind Bold title, a muted one-line description, then the fields stacked on the DS scale.
// Used by the admin settings pages, Account and the ops console so they all read the same.
import type { ReactNode } from "react";
import { Card } from "@grackle/ui";
import { Button } from "../components/ui";

export function SettingsSection({
  title,
  description,
  action,
  className,
  children,
}: {
  title: ReactNode;
  description?: ReactNode;
  /** Right side of the title row, e.g. a status badge. */
  action?: ReactNode;
  className?: string;
  children?: ReactNode;
}) {
  return (
    <Card as="section" className={["admin-section", className].filter(Boolean).join(" ")}>
      <div className="admin-section__head">
        <div className="admin-section__titles">
          <h4 className="admin-section__title">{title}</h4>
          {description ? <div className="admin-section__desc">{description}</div> : null}
        </div>
        {action}
      </div>
      {children}
    </Card>
  );
}

/** The prototype's save row: the one purple action on the view plus a ghost Cancel. */
export function SaveRow({
  onSave,
  onCancel,
  saving,
  disabled,
  saveLabel = "Save changes",
  status,
}: {
  onSave: () => void;
  onCancel?: () => void;
  saving?: boolean;
  disabled?: boolean;
  saveLabel?: string;
  /** Inline status beside the buttons: "Saved." or an error line. */
  status?: ReactNode;
}) {
  return (
    <div className="admin-save-row">
      <Button onClick={onSave} loading={saving} disabled={disabled}>
        {saveLabel}
      </Button>
      {onCancel ? (
        <Button variant="ghost" onClick={onCancel} disabled={saving}>
          Cancel
        </Button>
      ) : null}
      {status ? <span className="admin-save-row__status">{status}</span> : null}
    </div>
  );
}
